<template>
  <div>
    <div
      v-if="loading"
      class="col-md-12 text-center"
      style="margin-top:25%"
    >
      <PulseLoader
        :loading="loading"
      ></PulseLoader>
    </div>
    <div v-if="!loading">
      <div class="row">
        <div class="col-md-12 col-sm-12 ">
          <div class="">
            <div class="x_panel">
              <h2 class="float-left"> Sub Sub Component List</h2>
              <ul class="nav navbar-right panel_toolbox">
                <li>
                  <button v-if="isPermissionExist(PERMISSIONS.SUB_SUB_COMPONENT_CREATE)" type="button" class="btn btn-info btn-sm" @click="create">Add New <i class="fa fa-plus"></i></button>
                </li>
                <li  v-if="isPermissionExist(PERMISSIONS.SUB_SUB_COMPONENT_PRINT)">
                  <button
                    @click="handleExportPrint()" :disabled="isPrinting" class="btn btn-warning btn-sm float-right">
                    <i class="fa fa-print" v-if="!isPrinting"></i>
                    <i class="fa fa-spinner fa-spin" v-if="isPrinting"></i>
                    {{ isPrinting ? 'Printing...' : 'Print' }}
                  </button>
                </li>
                <li  v-if="isPermissionExist(PERMISSIONS.SUB_SUB_COMPONENT_PRINT)">
                  <vue-excel-xlsx
                    ref="excel"
                    :data="excelData"
                    :columns="excelHeader"
                    :file-name="'Sub Sub Component List'"
                    :file-type="'xlsx'"
                    :sheet-name="'sheetname'"
                    :disabled="isPrinting"
                    class="btn btn-primary btn-sm float-right"
                  >
                    <div
                      @click.prevent="handleExportPrint('excel')"
                    >
                      <i class="fa fa-file-excel-o"></i>
                      {{ isPrinting ? 'Preparing...' : 'Excel' }}
                    </div>
                  </vue-excel-xlsx>
                </li>
                <li>
                  <button @click="goBack" class="btn btn-danger btn-sm float-right">Back <i class="fa fa-arrow-circle-o-right"></i></button>
                </li>
              </ul>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div class="card">
                  <div class="card-body">
                    <div class="row justify-content-center">
                      <div class="col-md-2 col-6">
                        <div class="form-group">
                          <label for="">Department</label>
                          <select v-model="departmentId" name="department_id" class="form-control" @change="mainComponent(departmentId)">
                            <option value selected>Select Department</option>
                            <option v-for="sdepartment in departments" :key="sdepartment.id" :value="sdepartment.id">{{ sdepartment.name }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-2 col-6">
                        <div class="form-group">
                          <label for="">Main Component</label>
                          <select v-model="mainComponentId" name="main_component_id" class="form-control" @change="Component(mainComponentId)">
                            <option value selected>Select Main Component</option>
                            <option v-for="mainComponent in mainComponents" :key="mainComponent.id" :value="mainComponent.id">{{ mainComponent.name }}</option>
                          </select>
                        </div>
                      </div>

                      <div class="col-md-2 col-6">
                        <div class="form-group">
                          <label for="">Component</label>
                          <select v-model="componentId" name="component_id" class="form-control" @change="subComponent(componentId)">
                            <option value selected>Select component</option>
                            <option v-for="component in components" :key="component.id" :value="component.id">{{ component.name }}</option>
                          </select>
                        </div>
                      </div>

                      <div class="col-md-2 col-6">
                        <div class="form-group">
                          <label for="">Sub Component</label>
                          <select v-model="subComponentId" name="component_id" class="form-control" >
                            <option value="" selected>Select Sub component</option>
                            <option v-for="subcomponent in subcomponents" :key="subcomponent.id" :value="subcomponent.id">{{ subcomponent.name }}</option>
                          </select>
                        </div>
                      </div>

                      <div class="col-md-2 col-6 ">
                        <div class="form-group">
                          <label for="">Search </label>
                          <input type="text" placeholder="Enter component name or code" v-model="searchInput" name="searchInput" class="form-control">
                        </div>
                      </div>
                      <div class="col-md-1 mt-2">
                        <div class="form-group">
                          <label for=""></label>
                          <button class=" mt-3 btn-info btn btn-sm" @click="getData()">Search</button>
                        </div>
                      </div>
                    </div>

                    <div>
                      <label>Showing:</label>
                      <select
                        class="form-select mx-2"
                        style="width:120px"
                        v-model="offset"
                        @change="getData"
                      >
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </select>
                      <label>entries</label>
                    </div>

                    <div class="card-box table-responsive">
                      <p class="text-muted font-13 m-b-30"></p>
                      <table :class="getTableClasses" style="width:100%">
                        <thead>
                        <tr>
                          <th>#</th>
                          <th>Sub Sub Component Name</th>
                          <th> Code</th>
                          <th> Sub Component Name</th>
                          <th> Component Name</th>
                          <th> Main Component Name</th>
                          <th>Department Name</th>
                          <th>Critical Equipment</th>
                          <th>Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(subsubcomponent , index) in subsubcomponents?.data" :key="subsubcomponent.id">
                          <td>{{ (subsubcomponents?.current_page - 1) * subsubcomponents?.per_page + index + 1 }}</td>
                          <td>{{subsubcomponent.name}}</td>
                          <td>{{subsubcomponent.code}}</td>
                          <td>{{subsubcomponent?.parent?.name}}</td>
                          <td>{{subsubcomponent?.parent?.parent?.name}}</td>
                          <td>{{subsubcomponent?.maincomponent?.name}}</td>
                          <td>{{subsubcomponent?.department?.name}}</td>
                          <td>
                            <span class="badge badge-success" v-if="subsubcomponent.critical_equipment == 1">
                              Yes
                            </span>
                            <span v-else class="badge badge-danger">
                              No
                            </span>
                          </td>
                          <td>
                            <button type="button" @click="show(subsubcomponent)" class="btn btn-info btn-sm"><i class="fa fa-eye"></i></button>
                            <button type="button" v-if="isPermissionExist(PERMISSIONS.SUB_SUB_COMPONENT_EDIT)" @click="edit(subsubcomponent)" class="btn btn-primary btn-sm"><i class="fa fa-edit"></i></button>
                            <button type="button" v-if="isPermissionExist(PERMISSIONS.SUB_SUB_COMPONENT_DELETE) && false" @click="destroy(subsubcomponent)" class="btn btn-danger btn-sm"><i class="fa fa-trash"></i></button>
                            <button title="Copy Component" type="button" @click="subSubComponentnCopy(subsubcomponent)" class="btn btn-success btn-sm"><i class="fa fa-clone"
                                                                                                                                                          aria-hidden="true"></i>
                            </button>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                      <Pagination :pagination="subsubcomponents" :getData="getData"  />

                      <div id="printArea" style="display: none">
                        <div style="text-align: center;line-height: 20px;">
                          <h2 style="line-height: 10px;">{{ appName }}</h2>
                          <h4 style="line-height: 10px;">Vessel Name: {{this.vesselName}}</h4>
                          <div style="line-height: 10px;" class="font-weight-bold">Sub Sub Component List</div>
                          <p style="line-height: 10px;">Printing Date: {{new Date().toISOString().substring(0, 10)}}</p>
                          <table :class="getTableClasses" style="width:100%">
                            <thead>
                            <tr>
                              <th>#</th>
                              <th>Sub Sub Component Name</th>
                              <th> Code</th>
                              <th> Sub Component Name</th>
                              <th> Component Name</th>
                              <th> Main Component Name</th>
                              <th>Department Name</th>
                              <th>Critical Equipment</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(subsubcomponent , index) in printItems" :key="subsubcomponent.id">
                              <td>{{index + 1 }}</td>
                              <td>{{subsubcomponent.name}}</td>
                              <td>{{subsubcomponent.code}}</td>
                              <td>{{subsubcomponent?.parent?.name}}</td>
                              <td>{{subsubcomponent?.parent?.parent?.name}}</td>
                              <td>{{subsubcomponent?.maincomponent?.name}}</td>
                              <td>{{subsubcomponent?.department?.name}}</td>
                              <td>
                            <span class="badge badge-success" v-if="subsubcomponent.critical_equipment == 1">
                              Yes
                            </span>
                                <span v-else class="badge badge-danger">
                              No
                            </span>
                              </td>
                            </tr>
                            </tbody>
                          </table>

                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" id="roleModal" tabindex="-1" role="dialog" aria-labelledby="customerModalLongTitle" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="customerModalLongTitle">{{ editMode ? 'Edit' : 'Add ' }} Sub Sub Component </h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form @submit.prevent="editMode ? update() : store()" @keydown="form.onKeydown($event)">
              <div class="modal-body">
                <alert-error :form="form"></alert-error>
                <div class="row">
                  <div class="col-md-12 col-sm-12 col-12">

                    <div class="form-group">
                      <label>Department Name</label>
                      <select required v-model="form.department_id" name="department_id" class="form-control" :class="{ 'is-invalid': form.errors.has('department_id') }"
                              @change="mainComponent(form.department_id)">
                        <option value="" selected>Select department</option>
                        <option v-for="sdepartment in departments" :key="sdepartment.id" :value="sdepartment.id">{{sdepartment.name}}</option>
                      </select>
                      <has-error :form="form" field="department_id"></has-error>
                    </div>

                    <div class="form-group">
                      <label>Main Component </label>
                      <select required v-model="form.main_component_id" name="main_component_id" class="form-control" :class="{ 'is-invalid': form.errors.has('main_component_id') }"
                              @change="Component(form.main_component_id)">
                        <option value="" selected>Select component</option>
                        <option v-for="mainComponent in mainComponents" :key="mainComponent.id" :value="mainComponent.id">{{mainComponent.name}}</option>
                      </select>
                      <has-error :form="form" field="main_component_id"></has-error>
                    </div>
                    <div class="form-group">
                      <label> Component </label>
                      <select required v-model="component_id" name="component_id" class="form-control" :class="{ 'is-invalid': form.errors.has('component_id') }" @change="subComponent(component_id)">
                        <option value="" selected>Select component</option>
                        <option v-for="component in components" :key="component.id" :value="component.id">{{component.name}}</option>
                      </select>
                      <has-error :form="form" field="component_id"></has-error>
                    </div>
                    <div class="form-group">
                      <label> Sub Component </label>
                      <select required v-model="form.parent_id" name="parent_id" class="form-control" :class="{ 'is-invalid': form.errors.has('parent_id') }">
                        <option value="" selected>Select Sub Component</option>
                        <option v-for="subcomponent in subcomponents" :key="subcomponent.id" :value="subcomponent.id">{{subcomponent.name}}</option>
                      </select>
                      <has-error :form="form" field="parent_id"></has-error>
                    </div>


                    <div class="form-group">
                      <label> Name</label>
                      <input required autocomplete="off" v-model="form.name" type="text" name="name" class="form-control" :class="{ 'is-invalid': form.errors.has('name') }">
                      <has-error :form="form" field="name"></has-error>
                    </div>

                    <div class="form-group">
                      <label> Code</label>
                      <input required autocomplete="off" v-model="form.code" type="text" name="code" class="form-control" :class="{ 'is-invalid': form.errors.has('code') }">
                      <has-error :form="form" field="code"></has-error>
                    </div>

                    <div class="form-group">
                      <input id="criticalEquipment" autocomplete="off" v-model="form.critical_equipment" type="checkbox" name="code" class="mx-2" :class="{ 'is-invalid': form.errors.has('critical_equipment') }">
                      <has-error :form="form" field="critical_equipment"></has-error>
                      <label for="criticalEquipment">Critical Equipment </label>
                    </div>

                    <div class="form-group">
                      <label>Status</label>
                      <select v-model="form.status" name="status" class="form-control" :class="{ 'is-invalid': form.errors.has('status') }">
                        <option value="Activate">Activate</option>
                        <option value="Deactivate">Deactivate</option>
                      </select>
                      <has-error :form="form" field="status"></has-error>
                    </div>

                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button :disabled="form.busy" type="submit" class="btn btn-info">Save</button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="modal fade" id="copyModal" tabindex="-1" role="dialog" aria-labelledby="customerModalLongTitle" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="customerModalLongTitle">{{ editMode ? 'Edit' : 'Add ' }} Sub Sub Component </h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form @submit.prevent="store()" @keydown="form.onKeydown($event)">
              <div class="modal-body">
                <alert-error :form="form"></alert-error>
                <div class="row">
                  <div class="col-md-12 col-sm-12 col-12">
                    <div class="form-group">
                      <label> Name</label>
                      <input autocomplete="off" v-model="form.name" type="text" name="name" class="form-control" :class="{ 'is-invalid': form.errors.has('name') }">
                      <has-error :form="form" field="name"></has-error>
                    </div>
                  </div>
                  <div class="col-md-12 col-sm-12 col-12">
                    <div class="form-group">
                      <label> Code</label>
                      <input required autocomplete="off" v-model="form.code" type="text" name="code" class="form-control" :class="{ 'is-invalid': form.errors.has('code') }">
                      <has-error :form="form" field="code"></has-error>
                    </div>
                  </div>
                  <div class="form-group">
                    <input id="criticalEquipment" autocomplete="off" v-model="form.critical_equipment" type="checkbox" name="code" class="mx-2" :class="{ 'is-invalid': form.errors.has('critical_equipment') }">
                    <has-error :form="form" field="critical_equipment"></has-error>
                    <label for="criticalEquipment"> Critical Equipment</label>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button :disabled="form.busy" type="submit" class="btn btn-info">Save</button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <!-- Modal -->
      <div class="modal fade" id="showModal" tabindex="-1" role="dialog" aria-labelledby="showModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="showModalLabel">{{ form.name }}</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="modal-body">
              <div class="table-responsive">
                <table class="table table-striped table-bordered table-hover">
                  <tbody>
                  <tr>
                    <th>Name</th>
                    <td>{{ form.name }}</td>
                  </tr>
                  <tr>
                    <th>Manual Id</th>
                    <td>{{ form.manual_id }}</td>
                  </tr>
                  <tr>
                    <th>Main Component Name</th>
                    <td>
                      {{showInfo.mainComponentName}}
                    </td>
                  </tr>
                  <tr>
                    <th> Component Name</th>
                    <td>
                      {{showInfo.ComponentName}}
                    </td>
                  </tr>
                  <tr>
                    <th>Sub Component Name</th>
                    <td>{{ showInfo.subComponentName }}</td>
                  </tr>

                  <tr>
                    <th>Code</th>
                    <td>{{ form.code }}</td>
                  </tr>
                  <tr>
                    <th>Maker</th>
                    <td>{{ form.maker }}</td>
                  </tr>
                  <tr>
                    <th>Model</th>
                    <td>{{ form.model }}</td>
                  </tr>
                  <tr>
                    <th>Maker Ref Info</th>
                    <td>{{ form.maker_ref_info }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <div class="row">
                <div class="col-md-6"></div>
                <div class="col-md-6"></div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import auth from '../../auth'
    import PulseLoader from "vue-spinner/src/PulseLoader.vue";
    import Pagination from "@/components/Pagination/Pagination.vue";
    import {apiPrintData} from "@/utils/print";
    import goBackButtonMixin from "@/mixin/goBackButtonMixin";
    import PermissionsMixin from "@/mixin/permissionsMixin";

    export default {
        name: 'sub_sub_component',
        components: {Pagination, PulseLoader},
        mixins: [goBackButtonMixin, PermissionsMixin],
        data() {
            return {
                loading: false,
                editMode: false,
                isPrinting: false,
                appName: process.env.VUE_APP_NAME,
                vesselName: auth.getVesselName(),
                permissions: auth.getPermissionData(),
                printItems: [],
                query: '',
                queryFiled: 'name',
                departments: [],
                mainComponents: [],
                components: [],
                subcomponents: [],
                subsubcomponents: [],
                excelHeader: [],
                excelData: [],
                budgetHeads: [],
                component_id: '',
                departmentId: '',
                mainComponentId: '',
                componentId: '',
                subComponentId: '',
                searchInput: '',
                offset: 20,
                form: new Form({
                    id: '',
                    name: '',
                    code: '',
                    department_id: '',
                    main_component_id: '',
                    parent_id: '',
                    budget_head_id: '',
                    type: 'sub-sub-component',
                    critical_equipment: '',
                    vessel_id: auth.getVesselId(),
                    status: 'Activate'
                }),
                showInfo: {
                    mainComponentName: '',
                    ComponentName: '',
                    subComponentName: ''
                },
                pagination: {
                    current_page: 1
                },
                vessel_id: auth.getVesselId(),
            }
        },
        mounted() {
            this.departmentList()
            this.budgetHeadsList()
            this.getData()
        },
        watch: {
            'form.parent_id': function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.form.code = this.updateCode(newVal, this.subcomponents);
                }
            },
        },
        computed: {
          getTableClasses() {
            return {
              'table': true,
              'text-center': true,
              'table-striped': !this.isPrinting,
              'table-bordered': !this.isPrinting,
              'table-sm': !this.isPrinting,
              'print-table': this.isPrinting,
            };
          }
        },
        methods: {
            updateCode(parent_id, components) {
                const selectedComponent = components.find(component => component.id === parent_id);
                if (selectedComponent && selectedComponent.code) {
                    return selectedComponent.code;
                }
                return '';
            },
            getData(page = 1) {
                this.loading = true;
                var params = {
                  page: page,
                  is_all: 0,
                  department_id : this.departmentId,
                  main_component_id : this.mainComponentId,
                  component_id : this.componentId,
                  sub_component_id : this.subComponentId,
                  search : this.searchInput,
                  offset : this.offset,
                }
                this.$http.get('/api/filter/sub-sub-component/' + this.vessel_id, {params}).then(response => {
                    this.subsubcomponents = response.data.success
                    this.loading = false
                }).catch(e => {
                    this.loading = false

                    let response = e.response;
                    if (response.status === 403) {
                        this.$snotify.warning(response?.data?.error)
                    }
                })
            },

          prepareExportData(dataList) {
            let rows = [];
            if (!dataList || !dataList) return rows;

            dataList.forEach((item, index) => {
              rows.push({
                '#': index + 1,
                'Sub Sub Component Name': `${item?.name || ''}`,
                'Code': `${item?.code || ''}`,
                'Sub Component Name': `${item?.parent?.name || ''}`,
                'Component Name': `${item?.parent?.parent?.name || ''}`,
                'Main Component': `${item?.maincomponent.name || ''}`,
                'Department Name': `${item?.department?.name || ''}`,
                'Critical Equipment': `${item?.critical_equipment ==  1 ? 'Yes' : 'No'}`,
                'Status': `${item?.status == 'Activate' ? 'Active' : 'Inactive'}`,
              });
            });

            return rows;
          },

          excelExport(dataList) {
            let data = this.prepareExportData(dataList);
            if (!data || data.length === 0) {
              this.excelHeader = [];
              this.excelData = [];
              return;
            }

            // Build headers dynamically from the first row
            let excelHeader = Object.keys(data[0]).map(key => ({
              label: key,
              field: key
            }));

            this.excelHeader = excelHeader;
            this.excelData = data;
          },

          async handleExportPrint(type = 'print') {
            if (this.isPrinting) return

            this.isPrinting = true;

            try {
              const params = {
                is_all: 1,
                department_id : this.departmentId,
                main_component_id : this.mainComponentId,
                component_id : this.componentId,
                sub_component_id : this.subComponentId,
                search : this.searchInput,
                offset : this.offset,
              };

              const res = await this.$http.get('/api/filter/sub-sub-component/' + this.vessel_id, {params});
              const dataList = res?.data?.success ?? [];

              if (type === 'print'){
                this.printItems = dataList;
                this.$nextTick(() => {
                  apiPrintData('printArea', 'Sub Sub Component List');
                  this.isPrinting = false;
                });
              }

              if (type === 'excel'){
                this.excelExport(dataList);
                this.$nextTick(() => {
                  setTimeout(() => {
                    this.isPrinting = false;
                    this.$refs.excel.$el.click();
                  }, 200)
                });
              }

            } catch (error) {
              this.isPrinting = false;
              if (type == 'print') {
                printWindow.close();
              }
            }
          },
            create() {
                this.editMode = false
                this.form.reset()
                this.form.clear()
                $('#roleModal').modal('show')
            },
            store() {
                this.form.busy = true
                this.form.critical_equipment = this.form.critical_equipment == true ? 1 : 0;
                this.form.post('/api/component').then(response => {
                    $('.dataTables_empty').closest('tr').remove()
                    this.getData(Number(this.subsubcomponents?.current_page))
                    $('#roleModal').modal('hide')
                    $('#copyModal').modal('hide')
                    if (this.form.successful) {
                        this.$snotify.success(' Sub Component Created Successfully')
                    } else {
                        this.$snotify.error('Something went wrong try again later.')
                    }
                }).catch(e => {
                    let response = e.response;
                    if (response.status === 403) {
                        this.$snotify.warning(response?.data?.error)
                    } else {
                        var error = this.form.errors.errors.error
                        this.$snotify.error(error)
                    }

                })
            },
            subSubComponentnCopy(SubSubComponent) {
                this.component_id = SubSubComponent.parent?.parent.id
                this.form.reset()
                this.form.clear()
                this.form.fill(SubSubComponent)
                setTimeout(() => {
                  this.form.code = SubSubComponent.code;
                }, 1000)
                $('#copyModal').modal('show')
            },
            edit(SubSubComponent) {
                this.editMode = true;
                this.component_id = SubSubComponent.parent?.parent.id;
                this.form.reset();
                this.form.clear();
                this.form.fill(SubSubComponent);
                setTimeout(() => {
                    this.form.code = SubSubComponent.code;
                }, 1000);
                this.mainComponent();
                this.Component();
                this.subComponent();
                $('#roleModal').modal('show')
            },
            update() {
                this.form.busy = true;
                this.form._method = 'put';
                this.form.critical_equipment = this.form.critical_equipment == true ? 1 : 0;
                this.form.post('/api/component/' + this.form.id).then(response => {
                  this.getData(Number(this.subsubcomponents?.current_page))
                  $('#roleModal').modal('hide');
                    if (this.form.successful) {
                        this.$snotify.success(' component successfully Update')
                    } else {
                        this.$snotify.error('Something went wrong try again later.', 'Error')
                    }
                }).catch(e => {
                    let response = e.response;
                    if (response.status === 403) {
                        this.$snotify.warning(response?.data?.error)
                    }
                })
            },
            destroy(SubComponent) {
                this.$dialog.confirm('Do You Want to delete This ?').then(() => {
                    this.$http.delete('/api/component/' + SubComponent.id).then(response => {
                      this.getData(Number(this.subsubcomponents?.current_page))
                      this.$snotify.success(' Component Successfully Deleted')
                    }).catch(error => {
                        let response = error.response;
                        if (response.status === 403) {
                            this.$snotify.warning(response?.data?.error)
                        } else {
                            var err = error.response.data.error
                            this.$snotify.error(err)
                        }

                    })
                }).catch(function () {

                })

            },
            departmentList() {
                this.mainComponents = []
                this.components = []
                this.mainComponentId = ''
                this.componentId = ''
                var params = {
                  is_all: 1,
                }
                this.$http.get('/api/filter/department/' + this.vessel_id, {params}).then(response => {
                    this.departments = response.data.success
                }).catch(e => {
                    console.log(e)
                })
            },
            mainComponent(departmentId = null) {
                this.mainComponents = []
                this.components = []
                this.subcomponents = []
                this.componentId = ''
                var params = {
                  is_all: 1,
                }
                if (departmentId){
                  this.form.department_id = departmentId
                }

                if (this.form.department_id != '') {
                    this.$http.get('/api/filter/main-component/' + this.vessel_id + '/' + this.form.department_id, {params}).then(response => {
                        this.mainComponents = response.data.success
                    }).catch(e => {
                        console.log(e)
                    })

                } else {
                    this.mainComponents = []
                }
            },
            Component(mainComponentId = null) {
              this.subComponentId = ''
              var params = {
                is_all: 1,
              }
              if (mainComponentId){
                this.form.main_component_id = mainComponentId
              }
                if (this.form.main_component_id != '') {
                    this.$http.get('/api/filter/component/' + this.vessel_id + '/' + this.form.main_component_id, {params}).then(response => {
                        this.components = []
                        this.components = response.data.success
                    }).catch(e => {
                        console.log(e)
                    })
                } else {
                    this.components = []
                }
            },
            subComponent(subComponentId = null) {
              var params = {
                is_all: 1,
              }
              if (subComponentId){
                this.component_id = subComponentId;
              }
                if (this.component_id != '') {
                    this.$http.get('/api/filter/sub-component/' + this.vessel_id + '/' + this.component_id, {params}).then(response => {
                        this.subcomponents = []
                        this.subcomponents = response.data.success
                    }).catch(e => {
                        console.log(e)
                    })
                } else {
                    this.subcomponents = []
                }
            },
            budgetHeadsList() {
                this.$http.get('/api/filter/budget-head/' + this.vessel_id).then(response => {
                    this.budgetHeads = response.data.success
                }).catch(e => {
                    console.log(e)
                })
            },
            show(SubSubcomponent) {
                this.form.reset()
                this.form.fill(SubSubcomponent)
                this.showInfo.mainComponentName = this.isEmpty(SubSubcomponent.maincomponent) ? SubSubcomponent.maincomponent.name : ''
                this.showInfo.ComponentName = this.isEmpty(SubSubcomponent.parent) ? SubSubcomponent.parent.name : ''
                this.showInfo.subComponentName = this.isEmpty(SubSubcomponent.subcomponent) ? SubSubcomponent.subcomponent.name : ''
                $('#showModal').modal('show')
            },
            onImageChange(e) {
                let file = e.target.files[0]
                let reader = new FileReader()
                reader.onloadend = (file) => {
                    this.form.image = reader.result
                }
                reader.readAsDataURL(file)
            },

            isEmpty(obj) {
                var type = typeof obj
                if (type == 'object') {
                    if (obj.length < 1) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return false
                }
            },
            goBack() {
                this.$router.go(-1);
            },
        }
    }
</script>

<style scoped>

</style>
